__turbopack_context__.v({
  "blueAccentColor": "BannerCarousel-module-scss-module__Yw4Wia__blueAccentColor",
  "button": "BannerCarousel-module-scss-module__Yw4Wia__button",
  "lefGridItem": "BannerCarousel-module-scss-module__Yw4Wia__lefGridItem",
  "leftGridItem": "BannerCarousel-module-scss-module__Yw4Wia__leftGridItem",
  "lottieBannerResponsive": "BannerCarousel-module-scss-module__Yw4Wia__lottieBannerResponsive",
  "motionContainer": "BannerCarousel-module-scss-module__Yw4Wia__motionContainer",
  "orangeAccentColor": "BannerCarousel-module-scss-module__Yw4Wia__orangeAccentColor",
  "redAccentColor": "BannerCarousel-module-scss-module__Yw4Wia__redAccentColor",
  "rightGridItem": "BannerCarousel-module-scss-module__Yw4Wia__rightGridItem",
  "selected": "BannerCarousel-module-scss-module__Yw4Wia__selected",
  "tab": "BannerCarousel-module-scss-module__Yw4Wia__tab",
  "tabWrapper": "BannerCarousel-module-scss-module__Yw4Wia__tabWrapper",
  "tabsWrapper": "BannerCarousel-module-scss-module__Yw4Wia__tabsWrapper",
  "yellowAccentColor": "BannerCarousel-module-scss-module__Yw4Wia__yellowAccentColor",
});
